import * as React from 'react';
import { List, ListItem, ListItemText, styled } from '@mui/material';
import { useTranslate } from 'react-admin';
import { TimelinePlaceholder } from './TimelinePlaceholder';
import { EventAvatar } from '../EventAvatar';
export var RecordTimelineSkeleton = function (props) {
    var translate = useTranslate();
    var _a = props.length, length = _a === void 0 ? 2 : _a;
    return (React.createElement(Root, { "aria-disabled": true, "aria-label": translate('ra.message.loading') },
        React.createElement("div", null, times(length, function (key1) { return (React.createElement("div", { key: key1 },
            React.createElement(TimelinePlaceholder, { className: TimelineSkeletonClasses.subTitle }),
            React.createElement(List, null, times(5, function (key2) { return (React.createElement(ListItem, { key: key2 },
                React.createElement(ListItemText, { primary: React.createElement("div", { className: TimelineSkeletonClasses.authorContainer },
                        React.createElement(EventAvatar, { className: TimelineSkeletonClasses.avatar, size: "small" }),
                        React.createElement(TimelinePlaceholder, { className: TimelineSkeletonClasses.text })), secondary: React.createElement(TimelinePlaceholder, { className: TimelineSkeletonClasses.text }) }))); })))); }))));
};
var PREFIX = 'RaTimelineSkeleton';
export var TimelineSkeletonClasses = {
    subTitle: "".concat(PREFIX, "-subTitle"),
    text: "".concat(PREFIX, "-text"),
    authorContainer: "".concat(PREFIX, "-authorContainer"),
    avatar: "".concat(PREFIX, "-avatar"),
};
var Root = styled('div', {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            margin: 'auto'
        },
        _b["& .".concat(TimelineSkeletonClasses.subTitle)] = {
            width: '60%',
            paddingBottom: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        _b["& .".concat(TimelineSkeletonClasses.text)] = {
            width: '100%',
            marginBottom: theme.spacing(1),
        },
        _b["& .".concat(TimelineSkeletonClasses.authorContainer)] = {
            display: 'flex',
            alignItems: 'center',
        },
        _b["& .".concat(TimelineSkeletonClasses.avatar)] = {
            marginRight: theme.spacing(1),
        },
        _b);
});
var times = function (nbChildren, fn) { return Array.from({ length: nbChildren }, function (_, key) { return fn(key); }); };
